module.exports = __webpack_public_path__ + "img/filtersorticon.b7015046.svg";